import CommitOutlinedIcon from "@mui/icons-material/CommitOutlined";
import FiberManualRecordOutlinedIcon from "@mui/icons-material/FiberManualRecordOutlined";
import OnDeviceTrainingIcon from "@mui/icons-material/OnDeviceTraining";
import PeopleIcon from '@mui/icons-material/People';
import { Chip, useTheme } from "@mui/material";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid2";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import * as React from "react";
import { Link } from "react-router-dom";
import i18nStore from "../../../i18n/store";
import getFromNow from "../../../utils/dateutils";
import { ProjectInterface } from "../interfaces";
import projectStore from "../store";


const ProjectList = observer(() => {

    useEffect(() => {
        projectStore.prefetchData();
    }, []);

    return (
        <>
            <Grid container sx={{py: 2}}>
                <Grid
                    size={{xs: 12, md: 8}}
                    sx={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 2,
                    }}
                >
                    {
                        projectStore.getProjects.map((project, index, arr) => (
                            <Box key={index}>
                                <ProjectItem project={project}/>
                                {index !== arr.length - 1 && <Divider/>}
                            </Box>
                        ))
                    }
                </Grid>
            </Grid>
        </>
    );
});

export default ProjectList;


interface ProjectItemProps {
    project: ProjectInterface;
}
const ProjectItem = observer((props: ProjectItemProps) => {
    const theme = useTheme();
    const translations = i18nStore.getTranslations;

    return (
        <Box
            sx={{
                p: 1,
            }}
        >
            <Box sx={{ display: "flex", alignItems: "flex-end" }}>
                <Link to={`${props.project.id.toString()}`}>
                    <Typography
                        sx={{
                            color: theme.palette.primary.main,
                            fontWeight: 600,
                            textDecoration: "underline",
                            textAlign: "end",
                            "&:hover": {
                                cursor: "pointer",
                                textDecoration: "underline",
                                color: theme.palette.primary.dark,
                            },
                        }}
                    >
                        {props.project.title}
                    </Typography>
                </Link>
                <Chip
                    label={props.project.total_users === 1 ? translations._projects.personal : translations._projects.shared}
                    size="small"
                    variant="outlined"
                    sx={{ ml: 2, fontSize: "0.77rem", p: 0, color: theme.palette.grey.A700 }}
                />
            </Box>

            <Typography sx={{
                color: theme.palette.grey.A700,
                fontSize: "0.9rem",
            }}>
                {props.project.description}
            </Typography>
            <Box sx={{display: "flex", alignItems: "center", color: theme.palette.grey.A700, pt: 1}}>

                <Tooltip title={translations.nodes}>
                    <Box sx={{display: "flex", "&:hover": {color: theme.palette.primary.main}}}>
                        <FiberManualRecordOutlinedIcon/>
                        <Typography mr={2} fontSize="0.9rem" sx={{"&:hover": {color: "blue"}}}>
                            {props.project.total_nodes}
                        </Typography>
                    </Box>
                </Tooltip>

                <Tooltip title={translations.equipments}>
                    <Box sx={{display: "flex", "&:hover": {color: theme.palette.primary.main}}}>
                        <OnDeviceTrainingIcon/>
                        <Typography mr={2} fontSize="0.9rem" sx={{"&:hover": {color: "blue"}}}>
                            {props.project.total_equipments}
                        </Typography>
                    </Box>
                </Tooltip>

                <Tooltip title={translations.branches}>
                    <Box sx={{display: "flex", "&:hover": {color: theme.palette.primary.main}}}>
                        <CommitOutlinedIcon/>
                        <Typography mr={2} fontSize="0.9rem">
                            {props.project.total_branches}
                        </Typography>
                    </Box>
                </Tooltip>

                <Typography fontSize="0.85rem">
                    {translations.updated} {getFromNow(props.project.updated_at)} {translations.ago}
                </Typography>

                {
                    (props.project.total_users || 0) > 1 &&
                    <Tooltip title={translations.users}>
                        <Box sx={{ display: "flex", "&:hover": {color: theme.palette.primary.main}, ml: 4 }}>
                            <PeopleIcon />
                            <Typography mr={2} fontSize="0.9rem">
                                {props.project.total_users}
                            </Typography>
                        </Box>
                    </Tooltip>
                }

            </Box>
        </Box>
    );
});
